var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div class=\"message-icon-container\"><i class=\"fa fa-spin\" ng-if=\"$ctrl.spin\"></i> <svg class=\"svg-icon\" ng-if=\"!$ctrl.spin\"><use href=\"#openBox\"></use></svg><p class=\"no-records\">{{$ctrl.message}}</p></div>";
var id1="message-icon.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;